import React, { Component } from 'react';
import {Card, CardText} from 'material-ui/Card';
import {Row, Col} from 'react-flexbox-grid/lib';

import * as settings from 'settings/settings';
import styles from './styles/GoogleMapLoadSinglePinStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import GoogleMapSpeedPinList from 'containers/maps/GoogleMapSpeedPinList';
import moment from 'moment';
import {convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';

import startPin from 'Content/Assets/images/maps/green_48.png';
import endPin from 'Content/Assets/images/maps/red_48.png';

/**
 * carica lista di pin su mappa in base ai dati sulla velocità
*/
class SpeedPinList extends Component {

    render() {
        console.info("google map speed pin list container rendered");

        var { translate, icn, icnPlus, currentLanguage, isMilesPerHour, pdof, speedList} = this.props;

        var gpsposition = { lat: -34.397, lng: 150.644 };
        var addres = "";
        var dateTime = null;
        /*
            la velocità salvata nell'icn è sempre in miles per hour
        */
        var preCrashSpeed;
        var unitOfMeaserLabel = translate('GLOBAL.miph');

        if(icn)
        {
            preCrashSpeed = icn.speed;

            gpsposition = { lat: icn.latitude, lng: icn.longitude };
            addres = icn.street1 + " " + icn.street2 + ", " + icn.city + " - " + icn.country;

            var momentutc = moment.utc(icn.crashDate);
            momentutc.locale(currentLanguage);

            dateTime = "UTC " + momentutc.format("L") + " " + momentutc.format("LT");

            if(!isMilesPerHour)
            {
                preCrashSpeed = parseFloat(convertMiPerHourToKmPerHour(icn.speed));
                unitOfMeaserLabel = translate('GLOBAL.kmph');
            }
        }

        var pinList = [];
        if(speedList && speedList.length > 0)
        {
            for(var i=0;i<speedList.length;i++){
                var speedItem = speedList[i];

                var speed = speedItem.speed;

                if(!isMilesPerHour)
                {
                    speed = parseFloat(convertMiPerHourToKmPerHour(speedItem.speed));
                }

                /*
                    se è il punto dell'incidente non devo mostrare alcun inforwindows, ha già il suo
                */

                var showInfoWindows = true;
                if(gpsposition.lat === speedItem.latitude && gpsposition.lng ===speedItem.longitude )
                {
                    showInfoWindows = false;
                }

                var speedPin = {
                    position:{
                        lat: speedItem.latitude, lng: speedItem.longitude
                    },
                    speed,
                    unitOfMeaserLabel,
                    icon: null,
                    showPin: speedItem.time === 0,
                    isIncidentPin: speedItem.time === 0,
                    showInfoWindow: showInfoWindows,
                    name: speedItem.latitude.toString() + speedItem.longitude.toString()
                };
                pinList.push(speedPin);
            }

            /*
                cambio icona e rendo visibili il primo e l'ultimo pin
                gli altri saranno nascosti ma verranno utilizzati per il caricamento
                del polyline
            */

            pinList[0].icon = startPin;
            pinList[0].showPin = true;
            pinList[pinList.length -1].icon = endPin;
            pinList[pinList.length -1].showPin = true;
        }

        return (
            <div>
                {icn ?
                    <Row style={styles.mapContainer} >
                        <Col xs={12}>
                            <Card initiallyExpanded={true}>
                                <CardText expandable={true} >
                                    <GoogleMapSpeedPinList isMarkerShown={icn !== null}
                                        isMilesPerHour = {isMilesPerHour}
                                        centerPosition = {gpsposition}
                                        zoom={16}
                                        pinList={pinList}
                                        showPolyLine={true}
                                        addres={addres}
                                        dateTime={dateTime}
                                        icnPlus={icnPlus}
                                        pdof={pdof}
                                        speed={preCrashSpeed}
                                        unitOfMeaserLabel={unitOfMeaserLabel}
                                        icnId = {icn.id}
                                        googleMapURL={settings.googleMapUrl}
                                        loadingElement={<div style={{ height: `100%` }} />}
                                        containerElement={<div style={{ height: `600px` }} />}
                                        mapElement={<div style={{ height: `100%` }} />} />
                                </CardText>
                            </Card>
                        </Col>
                    </Row>
            :
                <SpinnerLoaderWithText />
            }
            </div>
        );
    }
}

SpeedPinList.propTypes = {

};

export default SpeedPinList;


// WEBPACK FOOTER //
// ./src/containers/maps/SpeedPinList.js